import ImageFragment from '@/lib/fragments/image'

import { graphql } from '@/lib/query'

const SectionImageListFragment = graphql(
  /* GraphQL */ `
    fragment SectionImageListFragment on SectionImageListRecord @_unmask {
      id
      _modelApiKey
      __typename
      images {
        ...ImageFragment
      }
      background
    }
  `,
  [ImageFragment]
)

export default SectionImageListFragment
